import { AddressesUsers } from "../modules";

export const AddressesUsersPage = () => {
  return <AddressesUsers />;
};
